<template>
  <div>
    <div class="loadingWrap" v-if="flag.search_flag" v-cloak></div>
    <div id="searchTips" :class="[flag.search_flag?'':'no']">
      <img src="../assets/success.png" alt="" v-if="flag.tipsCode == 1">
      <img src="../assets/error.png" alt="" v-if="flag.tipsCode == 2">
      <img src="../assets/loading.gif" alt="" v-if="flag.tipsCode == 3">
      <p>{{flag.tips}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "tips",
    props: ['flag']
  }
</script>

<style scoped lang="scss">
  #searchTips {
    min-width: 200px;
    min-height: 50px;
    background: #2E2E2E;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    padding: 0 10px;
    box-sizing: border-box;
    visibility: visible;
    opacity: 1;
    transition: opacity 0.3s;
    img {
      width: 20px;
      margin-right: 10px;
    }
    p {
      font-size: 17px;
      color: #fff;
    }
  }

  #searchTips.no {

    visibility: hidden;
    opacity: 0;
    /*display: none;*/
  }
  .loadingWrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }
  [v-cloak] {
    display:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/tips.vue